<script lang="ts">
	import { Loader, type LoaderOptions } from '@googlemaps/js-api-loader'
	import Spinner from './Spinner.svelte'

	interface $$Props extends LoaderOptions {} 

	const load = new Loader($$props as LoaderOptions).load()
</script>

{#await load}
	<Spinner />
{:then maps}
	<slot />
{/await}